<template>
  <div class="orderitem">
    <div class="orderid">
      订单编号：{{ item.orderId }}
    </div>
    <z-divider></z-divider>
    <div class="productitem">
      <div
        class="item-pic"
        :style="{ backgroundImage: 'url(' + $setPicSize(item.infoPic) + ')' }"
      >
      </div>
      <div class="item-info">
        <div class="item-info-title">
        {{ item.infoTitle }}
        </div>
        <div class="item-info-bottom">
          <div class="item-info-price">
            <div v-if="item.price / 100 > 0">
              ￥<span>{{ item.price / 100 }}</span>
            </div>
          </div>
          <div class="item-info-status">
            {{ item.status }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Divider } from '@zz-common/zz-ui'
import { setPicSize } from '@zz-common/zz-utils'
export default {
  name: 'OrderItem',
  props: ['item'],
  components: {
    'z-divider': Divider
  },
  data() {
    return {
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 144, 144)
    }
  }
}
</script>
<style lang="less" scoped>
@import 'index.less';
</style>